export * from './settings-selectors'



/** WEBPACK FOOTER **
 ** ./src/selectors/settings/index.js
 **/